import { gql } from '@apollo/client';

export const PREVIEW_TEXT_TO_SPEECH = gql`
    mutation($data: PreviewTextToSpeechInput!) {
        previewTextToSpeech(data: $data) {
            ... on TextToSpeechPreview {
                audioBase64
                mimeType
                voice
                style
            }
            ... on TextToSpeechPreviewError {
                message
            }
        }
    }
`;
